<h1 mat-dialog-title>Ajouter un IBAN</h1>
<div id="add-rib-form" mat-dialog-content>
  <mat-form-field appearance="fill" class="field">
    <mat-label>IBAN</mat-label>
    <input [(ngModel)]="data.codeIban" [formControl]="iban" matInput>
    <mat-hint align="end">{{iban.value?.length || 0}}/27</mat-hint>
    @if (iban.invalid) {
      <mat-error>{{getErrorIban()}}</mat-error>
    }
  </mat-form-field>
</div>
<div class="actions" mat-dialog-actions>
  <button [disabled]="!iban.valid" [mat-dialog-close]="data" class="green-button" mat-button>Enregistrer</button>
  <button (click)="onNoClick()" class="cancel" mat-button>Annuler</button>
</div>
